<script setup lang="ts">
  // Renders nothing of its own: lets a journey's routes be grouped under a
  // parent record without adding a URL segment or its own chrome.
</script>

<template>
  <RouterView />
</template>
